var _style, _g, _rect, _rect2, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGraphicRecoveryKeyHintmin = function SvgGraphicRecoveryKeyHintmin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 239,
    height: 180,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes smallCloudAnimation{0%{transform:translateX(-70px)}to{transform:translateX(0)}}@keyframes bulbLeftEyeAnimation{0%,10%{fill:#00b3f4}20%,to{fill:#fff}}@keyframes bulbMouthAnimation{0%,30%{fill:#00b3f4}40%,to{fill:#fff}}@keyframes bulbRightEyeAnimation{0%,20%{fill:#00b3f4}30%,to{fill:#fff}}@keyframes pinkLineAnimation{0%,to{stroke-dashoffset:6;stroke-dasharray:10}50%{stroke-dashoffset:0;stroke-dasharray:10}}.animate-pulse-stroke{animation:pinkLineAnimation 2s linear infinite}")), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5169_13123)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M125.052 55.506c.137 0 .273.007.409.01v-.01c0-11.877 9.804-21.506 21.898-21.506 9.821 0 18.132 6.35 20.909 15.097a15.2 15.2 0 0 1 7.016-1.701c8.33 0 15.083 6.632 15.083 14.812 0 1.333-.183 2.624-.519 3.852a12.3 12.3 0 0 1 4.947-1.034c6.74 0 12.205 5.367 12.205 11.987S201.535 89 194.795 89h-69.743C115.634 89 108 81.502 108 72.253s7.634-16.747 17.052-16.747",
    style: {
      animation: "smallCloudAnimation 3s 1 ease-in-out"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5169_13123)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M163.614 79.41c-.221 0-.438.011-.658.017l.001-.017c0-19.004-15.746-34.41-35.17-34.41-15.773 0-29.12 10.16-33.58 24.155a24.54 24.54 0 0 0-11.27-2.722c-13.378 0-24.223 10.611-24.223 23.7 0 2.133.293 4.197.833 6.163a19.9 19.9 0 0 0-7.944-1.655C40.776 94.641 32 103.228 32 113.82 32 124.413 40.776 133 51.603 133h112.011C178.739 133 191 121.004 191 106.205c0-14.798-12.261-26.795-27.386-26.795"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 5,
    x: 115,
    y: 156,
    fill: "#0090ED",
    rx: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 5,
    x: 114,
    y: 149,
    fill: "#0090ED",
    rx: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00B3F4",
    d: "M119.549 143.851h12.709a6.715 6.715 0 0 0 6.632-5.583l1.218-7.759a22.71 22.71 0 0 0 6.39-27.495 22.7 22.7 0 0 0-6.22-7.918c-5.344-4.345-12.353-6.023-19.229-4.602-8.877 1.852-15.927 9.126-17.547 18.098-1.516 8.396 1.549 16.59 8.007 21.573l1.408 8.103a6.72 6.72 0 0 0 6.632 5.583"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m119.385 107.759.704 3.028h-2.994l.704-3.028-2.34 2.11-1.459-2.582 2.994-.894-2.994-.943 1.535-2.532 2.264 2.11-.704-3.028h2.994l-.73 3.078 2.366-2.16 1.484 2.582-3.095.918 3.095.919-1.535 2.532z",
    style: {
      animation: "bulbLeftEyeAnimation 3s ease-in-out"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m133.385 107.759.704 3.028h-2.994l.704-3.028-2.34 2.11-1.459-2.582 2.994-.894-2.994-.943 1.535-2.532 2.264 2.11-.704-3.028h2.994l-.73 3.078 2.366-2.16 1.484 2.582-3.095.918 3.095.919-1.535 2.532z",
    style: {
      animation: "bulbRightEyeAnimation 3s ease-in-out"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M132.546 119c.803 0 1.467.656 1.322 1.446a7.997 7.997 0 0 1-10.929 5.945 8 8 0 0 1-4.807-5.945c-.145-.79.519-1.446 1.322-1.446s1.434.664 1.66 1.434q.077.262.182.515a5.1 5.1 0 0 0 1.103 1.652 5.1 5.1 0 0 0 5.55 1.103 5.1 5.1 0 0 0 1.652-1.103 5.1 5.1 0 0 0 1.285-2.167c.226-.77.857-1.434 1.66-1.434",
    style: {
      animation: "bulbMouthAnimation 3s ease-in-out"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E31587",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "M95 113H85M102 90l-8-7M126 82V70M151 91l8-7M158 113h10",
    className: "animate-pulse-stroke"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5169_13123",
    width: 239,
    height: 119,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.564706 0 0 0 0 0.929412 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5169_13123"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5169_13123",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5169_13123",
    width: 223,
    height: 152,
    x: 0,
    y: 11,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.564706 0 0 0 0 0.929412 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5169_13123"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5169_13123",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGraphicRecoveryKeyHintmin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/graphic_recovery_key_hint.min.5f1a78b639aa8dcbf284155f2d10134b.svg";